import { useCallback } from 'react'
import { useNodeId } from '@xyflow/react'
import { useNodeCentering } from './useNodeCentering'

/**
 * 双击节点居中，再次双击回退视图
 */
export function useNodeDoubleClickCentering(nodeId?: string | null) {
  const contextNodeId = useNodeId()
  const id = nodeId ?? contextNodeId
  const { centerNodeById, centeredNodeId, restorePreviousViewport } = useNodeCentering()

  const handleDoubleClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      if (id && centeredNodeId === id) {
        restorePreviousViewport()
      } else {
        centerNodeById(id ?? '', { duration: 400 })
      }
    },
    [id, centeredNodeId, centerNodeById, restorePreviousViewport]
  )

  return { handleDoubleClick }
}
